import { LicenseType } from '~/types/licenses/licenses';

/**
 * What a member must do before we can file a manual deletion request on their behalf.
 * Mirrors the rules the deletion-guide flow already enforces, so the same member gets the
 * same answer wherever they ask.
 */
export type DeletionRequestGate = 'allowed' | 'needs_purchase' | 'needs_upgrade';

/** Essentials covers manual deletion for people-search companies only. */
const ESSENTIALS_DELETABLE_TYPES = ['people_search', 'people_search_affiliate'];

export interface DeletionEligibility {
    /** Slug of the member's active license, if they have one. */
    licenseSlug?: string | null;
    /** The company's type value, e.g. 'people_search'. */
    companyType?: string | null;
}

export const getDeletionRequestGate = ({
    licenseSlug,
    companyType,
}: DeletionEligibility): DeletionRequestGate => {
    if (!licenseSlug) {
        return 'needs_purchase';
    }

    if (licenseSlug === LicenseType.ESSENTIALS && !ESSENTIALS_DELETABLE_TYPES.includes(companyType ?? '')) {
        return 'needs_upgrade';
    }

    return 'allowed';
};
